import fetcher from '../utils/api';

const billingService = {
  getCustomerInfo: async (customerId) =>
    fetcher('stripe/get_customer_info/', 'GET', true, {
      customer_id: customerId
    }),
  createSubscriptionForReactivation: async (
    superOrganizationId,
    taxData,
    taxCalculationError,
    selectedPlanType,
    selectedPlanPeriod,
    isPlanModified
  ) =>
    fetcher('stripe/create_subscription_for_reactivation/', 'POST', true, {
      super_organization_id: superOrganizationId,
      tax_data: taxData,
      tax_calculation_error: taxCalculationError,
      selected_plan_type: selectedPlanType,
      selected_plan_period: selectedPlanPeriod,
      is_plan_modified: isPlanModified
    }),
  createSetupIntent: async (superOrganizationId, currency, includeBankAccount = false, isCreditCardTrial = false) =>
    fetcher('stripe/setup/', 'POST', true, {
      super_organization_id: superOrganizationId,
      currency,
      include_bank_account: includeBankAccount,
      is_credit_card_trial: isCreditCardTrial
    }),
  getNextBillingDate: async (superOrganizationId) =>
    fetcher(`stripe/billing_date/?super_organization_id=${superOrganizationId}`, 'GET', true),
  getProPrice: async (superOrganizationId, planPeriod, currency) =>
    fetcher(`stripe/price/?super_organization_id=${superOrganizationId}&plan_period=${planPeriod}&currency=${currency}`, 'GET', true),
  getEssPrice: async (priceId, sfdcAccountId, plan) => {
    let url = 'stripe/price/ess/';

    if (priceId && sfdcAccountId) {
      url += `?encoded_pid=${priceId}&sid=${sfdcAccountId}`;
    }
    if (plan) {
      if (url.includes('?')) {
        url += `&plan=${plan}`;
      } else {
        url += `?plan=${plan}`;
      }
    }
    return fetcher(url, 'GET', true);
  },
  getSuperOrganizationInfo: async (superOrganizationId) => fetcher(`super_organization/${superOrganizationId}/info/`, 'GET', true),
  getCredits: async (superOrganizationId) => fetcher(`super_organization/${superOrganizationId}/credits/`, 'GET', true),
  changePlan: async (superOrganizationId, planPeriod, planType, overrideSeatCount, sfdcAccountId, accountName, discount) =>
    fetcher('stripe/change_plan/', 'POST', true, {
      super_organization_id: superOrganizationId,
      plan_period: planPeriod,
      plan_type: planType,
      override_seat_count: overrideSeatCount,
      sfdc_account_id: sfdcAccountId,
      account_name: accountName
    }),
  changeSubscriptionPlan: async (superOrganizationId, newPlanPeriod, newPlanType, currency) =>
    fetcher('stripe/change_subscription_plan/', 'POST', true, {
      super_organization_id: superOrganizationId,
      new_plan_period: newPlanPeriod,
      new_plan_type: newPlanType,
      currency
    }),
  downgrade: async (superOrganizationId, upgradeReason, downgradeReason, explanation) =>
    fetcher('stripe/downgrade/', 'POST', true, {
      super_organization_id: superOrganizationId,
      upgrade_reason: upgradeReason,
      downgrade_reason: downgradeReason,
      explanation
    }),
  updateCustomerAddress: async (userId, superOrganizationId, address) =>
    fetcher('stripe/update_customer_address/', 'POST', true, {
      super_organization_id: superOrganizationId,
      user_id: userId,
      address
    }),
  reactivate: async (superOrganizationId) =>
    fetcher('stripe/reactivate/', 'POST', true, {
      super_organization_id: superOrganizationId
    }),
  applyPromotion: async (superOrganizationId, promotionCode) =>
    fetcher('stripe/promotion/', 'POST', true, {
      super_organization_id: superOrganizationId,
      promo_code: promotionCode
    }),
  processBaseUpgradeWithInvoice: async (
    memoInfo,
    billingEmail,
    numPurchasedSeats,
    taxData,
    taxCalculationError,
    billingDetails,
    taxExempt,
    poNumber
  ) =>
    fetcher('stripe/base_with_invoice/', 'POST', true, {
      memo_info: memoInfo,
      billing_email: billingEmail,
      num_purchased_seats: numPurchasedSeats,
      tax_data: taxData,
      tax_calculation_error: taxCalculationError,
      tax_exempt: taxExempt,
      billing_details: billingDetails,
      po_number: poNumber
    }),
  addPoNumber: async (userId, superOrganizationId, poNumber) =>
    fetcher('stripe/add_po_number/', 'POST', true, {
      super_organization_id: superOrganizationId,
      user_id: userId,
      po_number: poNumber
    })
};

export default billingService;
